import React, { useContext } from 'react'
import StoreContext from '../../providers/storesContext'
import CaseBillItem from './CaseBillItem'

const CaseBill = () => {
  const { caseDetailStore } = useContext(StoreContext)

  return (
    <div>
      <div className="font-bold pb-3">Violations &amp; Fees</div>
      {caseDetailStore.immobilizationCase.bill?.lineItems.map((lineItem, index) => (
        <CaseBillItem item={lineItem} key={`bill_${index}`} />
      ))}
    </div>
  )
}

export default CaseBill
